<template>
  <div class="historico-beneficiarios-filtro">
    <b-form>
      <div class="d-flex align-items-center p-4">
        <div class="title title-primary d-flex w-50 m-0">
          <DynamicIcon icon="color-pencil" classString="container-title-icon mr-2"/>
          <p class="d-flex align-items-center mt-1 optum-bold font-24px">Corrigir erros inesperados</p> 
        </div>
      </div>
      
      <ToogleFilterBox classString="mx-4" title="Filtrar" :isFilter="true" @filter="filter" @resetFilter="resetFilter">
        <div class="row col-md-12 m-0 p-0">
            <b-form-group label="Empresa:" label-for="empresa" class= "col-12 col-lg-6 px-1">
              <InputAutocomplete :loader="empresaAutocompleteLoader" v-model="form.empresa" />
            </b-form-group>
            <b-form-group label="ID da importação" label-for="importacaoId" class="col-12 col-lg-3 px-1">
                <b-form-input id="importacaoId" v-model="form.importacaoId" placeholder="Digite aqui"/>
            </b-form-group>
            <b-form-group label="Responsável pela importação" required label-for="nome" class="col-12 col-md-3 px-1">
              <b-form-input id="nome" v-model="form.nome" placeholder="Digite aqui" trim />
            </b-form-group>
        </div>       
      </ToogleFilterBox>

    </b-form>
  </div>
</template>

<script>
import Validations from '@/util/Validations'
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ToogleFilterBox from "@/components/commons/ToogleFilterBox.vue";
import EmpresaResource from "@/resources/EmpresaResource"
import InputAutocomplete from "@/components/commons/Inputs/InputAutocomplete"
import { mapGetters } from "vuex"
export default {
  
    name: "CorrigirErrosInesperadosFilter",
    components:{
      DynamicIcon,
      ToogleFilterBox,
      InputAutocomplete
    },
    props: {
      cleanFilter: Boolean,
      empresaOptions: Array,
      empresaSelected: Number,
    },
    data() {
      return {
        modal: null,
        acao: null,
        refresh: false,
        form : {
            nome: null,
            empresa: null,
            importacaoId: null
        }
      }
	},
  computed: {
      ...mapGetters("user", ["authorities"]),
      isAdmin () {
          if ( this.authorities ) {
              return this.authorities.includes("ROLE_ADMIN")
          }   
          return false;
      }
  },
  methods: {
    empresaAutocompleteLoader: EmpresaResource.autocomplete,
      filter() {
        if( Validations.isEmpty(this.form) ) {
          this.$emit("filter-errors-inesperados", {} )    
        }
        else {
            let form = {
                ...this.form,
                nome: this.form.nome != null ? this.form.nome.toUpperCase() : null,
                empresaId: this.form.empresa != null ? this.form.empresa.id : null
            }

          this.$emit("filter-errors-inesperados", form)
        }        
      },
      resetFilter() {
          for (let key in this.form)
          {
              this.form[key] = null
          }  
      },
      changeEmpresa()
      {
        this.filter()
      }
  },
  watch: {
    cleanFilter: function(newVal) {
      this.refresh = true
      if(newVal)
      {
        this.resetFilter()
        this.filter()
      }
    },
    empresaSelected: function(newVal) {
      this.form.empresa = newVal
    }
  }
}
</script>
<style scoped>
.historico-beneficiarios-filtro {
	justify-content: space-between;
  color: #707070;
	font-size: 18px;
	text-align: left;
}

.label-filter-cases {
    width: 100%;
    height: 45px;
    color: #EFEFEE !important;    
    background-color: #bbbec0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px !important;
    letter-spacing: 2px !important;
    border-radius: 10px 10px 0px 0px;
    transition: 0.2s;
}

.label-filter-cases:hover{
    cursor: pointer;
    background-color: #9d9fa0;
}

input, select {
    font-size: 14px !important;
    border: 1px solid #bbbec0 !important;  
}

.form-filter-cases, .form-filter-cases-flex  {
    width: 100%;
    display: flex;
    padding: 15px 0px;
    flex-wrap: wrap;
    transition: 0.2s;
    background-color: #fff;
    border-radius: 0px 0px 10px 10px;
}

.form-select {
  border: none !important;
  outline: none !important;
  scroll-behavior: smooth !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgb(0, 38, 119)' stroke-linecap='round' stroke-linejoin='round' stroke-width='4' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
  color: rgb(0, 38, 119) !important;
  font-weight: bold !important;
  cursor: pointer !important;
}

select.form-select option {
  border: none !important;
  outline: none !important;
  scroll-behavior: smooth !important;
  font-weight: bold !important;
}

</style>